import React, { ComponentProps } from 'react';
import { BlockType } from '../../types/api/ElementType';
import { asBlock } from '../../_lib/BlockFetcher';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { BlockGuard } from '../../types/api/Block';
import { Dfn } from '../../_lib/components/Dfn/Dfn';
import { FooterLink, FooterNavItem } from './partials/FooterLink';

export interface FooterProps {
  footerNavItems?: FooterNavItem[];
}

export function Footer({ footerNavItems = [] }: FooterProps) {
  const { t } = useSonTranslation('FooterSection');
  const { appVersion } = useAppContext();

  // the footer links are a hard coded array of links that belong in two lists, see SonPageType.java
  // there should be two lists, one with accessibility infos and ALL OTHERS in legal infos
  const pageTypesInAccessibilityList = ['accessibilitystatement', 'help', 'simplelanguage', 'signlanguage'];

  const { group1, group2 } = footerNavItems.reduce<{ group1: FooterNavItem[]; group2: FooterNavItem[] }>(
    (acc, item) => {
      if (pageTypesInAccessibilityList.includes(item.pageType)) {
        acc.group2.push(item);
      } else {
        acc.group1.push(item);
      }
      return acc;
    },
    { group1: [], group2: [] },
  );

  return (
    <div className="footer__inner">
      {
        footerNavItems && footerNavItems.length > 0 && (
          <nav className="footer__navigation" aria-label={t('navTitle')}>
            <ul className="footer__list" aria-label={t('legalMatters')} key="legallist">
              {group1.map((legalItem: FooterNavItem) => (
                <FooterLink item={legalItem} key={legalItem?.pageType} />
              ))}
            </ul>
            <ul className="footer__list" aria-label={t('helpAccessibility')} key="a11ylist">
              {group2.map((a11yItem: FooterNavItem) => (
                <FooterLink item={a11yItem} key={a11yItem?.pageType} />
              ))}
            </ul>
          </nav>
        )
      }
      <p className="footer__app-version font-light-13-17">
        <Dfn>{t('versionLabel')}:</Dfn> {appVersion}
      </p>
    </div>
  );
}

export const FooterBlock = asBlock(Footer, BlockType.footer);
export type FooterBlock = ComponentProps<typeof FooterBlock>;
export const isFooterBlock = BlockGuard<FooterBlock>(BlockType.footer);
